import React from 'react';
import PropTypes from 'prop-types';
import {Toggle} from '@/components/atoms';
import {TextInputField} from '@/components/molecules';
import {COUNTRY_CODES_DISABLE_TAX_FROM_GOAL} from '@/utils/constants/globalConstants';

const AdditionalOptionsSection = ({formData, countryCode, onChange}) => {
  const handleToggleChange = (field, val) => {
    onChange({...formData, [field]: val});
  };

  const handleRoundUpAmountChange = (val, isValid) => {
    onChange({
      ...formData,
      roundOffValue: val,
      roundOffValueValid: isValid
    });
  };

  return (
    <div className='filters-partners'>
      <div className='flex flex-row flex-wrap gap-6'>
        <Toggle
          value={!!formData?.joinCampaignFlag}
          updateValue={(val) => handleToggleChange('joinCampaignFlag', val)}
          uiSchema={{
            label: 'Users need to join this campaign?',
            isDark: true,
            showCheckedIcon: false
          }}
        />
        <Toggle
          value={!!formData?.excludeTaxFromGoal}
          updateValue={(val) => handleToggleChange('excludeTaxFromGoal', val)}
          uiSchema={{
            label: 'Exclude tax from goal?',
            isDark: true,
            showCheckedIcon: false
          }}
          disabled={COUNTRY_CODES_DISABLE_TAX_FROM_GOAL.includes(countryCode)}
        />
        <Toggle
          value={!!formData?.offlineOrdersIncluded}
          updateValue={(val) =>
            handleToggleChange('offlineOrdersIncluded', val)
          }
          uiSchema={{
            label: 'Include Offline Orders?',
            isDark: true,
            showCheckedIcon: false
          }}
        />
      </div>
      <div className='avail-second-round'>
        <Toggle
          value={!!formData?.roundUpPointsFlag}
          updateValue={(val) => handleToggleChange('roundUpPointsFlag', val)}
          uiSchema={{
            label: 'Round up points?',
            isDark: true,
            showCheckedIcon: false
          }}
        />
      </div>
      {formData?.roundUpPointsFlag && (
        <div className='avail-second-row mt-6'>
          <TextInputField
            value={formData?.roundOffValue ?? ''}
            updateValue={handleRoundUpAmountChange}
            label='Round Up Amount*'
            schema={{type: 'string'}}
            uiSchema={{
              className: 'box-size-width',
              placeholder: 'Round Up Amount',
              isDark: true,
              validationRules: [
                {type: 'required', msg: ` is required`},
                {
                  type: 'number',
                  msg: ` Please enter a valid numeric round up amount`,
                  excludeLabel: true
                }
              ]
            }}
            visible={true}
          />
        </div>
      )}
    </div>
  );
};

AdditionalOptionsSection.propTypes = {
  formData: PropTypes.object.isRequired,
  countryCode: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default React.memo(AdditionalOptionsSection);
